/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Button from 'components/Button.jsx';
import Input from 'components/Input.jsx';

import './SearchExpanding.scss';

type Props = {
  buttonProps: Object,
  children?: any,
  className?: string,
  inputProps?: Object,
};

type State = {
  searchActive: boolean,
};

export default class SearchExpanding extends React.Component<Props, State> {
  state: State = {
    searchActive: false,
  };

  render() {
    const { buttonProps, children, className, inputProps } = this.props;
    const { searchActive } = this.state;

    return (
      <div className="SearchExpanding">
        <div
          className={cx(
            'SearchExpanding-input',
            searchActive && 'SearchExpanding-input--active',
            className
          )}>
          <Input
            {...inputProps}
            button
            glyph="search"
            placeholder="Search"
            onBlur={() => this.setState({ searchActive: false })}
            onFocus={() => this.setState({ searchActive: true })}
          />
        </div>
        {searchActive ? <Button {...buttonProps}>Cancel</Button> : children}
      </div>
    );
  }
}
